export default __webpack_public_path__ + "static/media/gallery.ba00baed.webp";